module.exports = __webpack_public_path__ + "img/amanda.04924d73.png";